var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.data && _vm.data.length)?_c('span',_vm._l((_vm.data),function(datum){return _c('b-badge',{key:_vm.data.indexOf(datum),staticClass:"mr-1",attrs:{"variant":"primary"}},[_vm._v(_vm._s(datum ? datum[_vm.dataKey] : ''))])}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }